import { useEffect, useState } from "react";
import { Asset, AssetGroup } from "../models/asset";

function useUptimeSidebar(allTags: AssetGroup[], allAssets: Asset[]) {
    const [searchQuery, setSearchQuery] = useState("");

    const [selectedTags, setSelectedTags] = useState<Set<string>>(new Set<string>());

    const [tagWithAssets, setTagWithAssets] = useState<{ [tagId: string]: { assets: Asset[], assetsIds: string[], selectedAssetIds: Set<string> } }>();

    useEffect(() => {
        const tagWithAssets: { [tagId: string]: { assets: Asset[], assetsIds: string[], selectedAssetIds: Set<string> } } = {};
        allTags.forEach((tag) => {
            tagWithAssets[tag.id] = {
                assets: allAssets.filter((asset) => asset.groupIds?.includes(tag.id)),
                assetsIds: allAssets.filter((asset) => asset.groupIds?.includes(tag.id)).map((asset) => asset.id),
                selectedAssetIds: new Set<string>()
            };
        });
        setTagWithAssets(tagWithAssets);
        addAllTags();
    }, [allTags, allAssets]);

    const [viewMode, setViewMode] = useState("assets");
    const getSearchLabel = (viewMode: string) => {
        switch (viewMode) {
            case "assets":
                return "Buscar veículos";
            case "tags":
                return "Buscar grupos";
        }
    }

    const handleFilter = (term: string) => {
        setSearchQuery(term);
    }

    const getVehicleTypeCount = (vehicleType: string): number => {
        return allAssets
        .filter((asset) => {
            if(!searchQuery) return true;
            if(viewMode === "assets") return asset.chassis?.toLowerCase().includes(searchQuery.toLowerCase());
            return true;
        })
        .filter((asset) => asset.type === vehicleType).length;
    }

    const addTag = (tagId: string) => {
        selectedTags.add(tagId);
        setTagWithAssets(prev => ({ ...prev, [tagId]: { ...prev![tagId], selectedAssetIds: new Set([...prev![tagId].assetsIds]) } }));
    };
    const removeTag = (tagId: string) => {
        selectedTags.delete(tagId);
        setTagWithAssets(prev => ({ ...prev, [tagId]: { ...prev![tagId], selectedAssetIds: new Set() } }));
    };

    const addAllTags = () => {
        setSelectedTags(new Set(allTags.filter(el => el.id).map((tag: AssetGroup) => tag.id)));
        allTags.forEach((tag: AssetGroup) => {
            setTagWithAssets(prev => ({ ...prev, [tag.id]: { ...prev![tag.id], selectedAssetIds: new Set([...prev![tag.id].assetsIds]) } }));
        });
    };
    const removeAllTags = () => {
        setSelectedTags(new Set());
        allTags.forEach((tag: AssetGroup) => {
            setTagWithAssets(prev => ({ ...prev, [tag.id]: { ...prev![tag.id], selectedAssetIds: new Set() } }));
        });
    };

    return {
        tagWithAssets,
        viewMode,
        setViewMode,
        getSearchLabel,
        handleFilter,
        selectedTags,
        getVehicleTypeCount,
        searchQuery,
        setSearchQuery,
        addTag,
        removeTag,
        addAllTags,
        removeAllTags,
    }
}

export default useUptimeSidebar;